/*
    a Hook to retreive and store queries user searches in the search-suggestion component
*/
import { useCookies } from 'react-cookie'

import { useCallback, useMemo } from 'react'

import { SearchItemWithImageViewModel } from '@/types/api'

import { generateSearchUrl } from './search-helpers'

import { SEARCH_HISTORY_LOCAL_KEY, SEARCH_HISTORY_MAX_ITEMS } from '../constants'

export default function useSearchHistory() {
    const [cookies, setCookies, removeCookie] = useCookies<string, { [key: string]: string[] }>([
        SEARCH_HISTORY_LOCAL_KEY,
    ])

    const addItemToSearchHistory = useCallback(
        (item: string) => {
            const items = cookies?.[SEARCH_HISTORY_LOCAL_KEY] || []

            if (items.includes(item)) {
                items.splice(items.indexOf(item), 1)
            }

            setCookies(SEARCH_HISTORY_LOCAL_KEY, [item, ...items].slice(0, SEARCH_HISTORY_MAX_ITEMS))
        },
        [cookies, setCookies]
    )

    const clearSearchHistory = useCallback(() => {
        removeCookie(SEARCH_HISTORY_LOCAL_KEY)
    }, [removeCookie])

    const searchHistoryItems = useMemo(() => {
        const items = cookies?.[SEARCH_HISTORY_LOCAL_KEY] || []

        if (!items.length) return null

        return items.map<SearchItemWithImageViewModel>((item, index) => ({
            id: `${index}`,
            nameFa: item,
            slug: generateSearchUrl(item),
            queryId: null,
        }))
    }, [cookies])

    return {
        searchHistoryItems,
        addItemToSearchHistory,
        clearSearchHistory,
    }
}
